import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'
import {
  showLoading,
  hideLoading
} from '@/assest/utils/loading'
import store from '@/store'

// 配置环境
var domain = window.location.host,
  port = location.port,
  wurl = window.location.href
if (port != '')
  domain = domain.substr(0, domain.indexOf(':' + port))

const host = process.env.NODE_ENV === 'development' ? process.env.API_HOST : domain

const options = {
  baseURL: wurl.substr(0, wurl.indexOf('://')) + '://' + host + '/public',
  timeout: 1000 * 120, // 创建axios实例,设定超时时间是12s
  withCredentials: process.env.NODE_ENV === 'development' ? false : true, // 允许携带cookie
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
  }
}
var load_options = {
  lock: true,
  text: '正在加载...',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.6)',
  target: document.querySelector('#AdminMain')
}
var noneload = 2,
  cancelflag = 2

const instance = axios.create(options)

// 仅影响主动携带上下文的请求提示，不改变请求、错误传递或加载计数。
function shouldNotifyError(config) {
  if (!config || typeof config.isErrorContextCurrent !== 'function') return true
  try {
    return config.isErrorContextCurrent() === true
  } catch (error) {
    // 上下文已失效时也必须继续完成原请求收尾，不能用校验异常中断拦截器。
    return false
  }
}

function createRequestLoading(config) {
  // 每次发送都创建新状态，不能继承重试配置中上一次请求的登记结果。
  const state = { registered: false, finished: false }
  config._kdFinishLoading = () => {
    if (state.finished) return
    // 先占住收尾权，避免取消、适配器及响应拦截器重复安排减计数。
    state.finished = true
    if (state.registered) setTimeout(() => hideLoading(), 200)
  }
  return state
}

function finishRequestLoading(config) {
  if (config && typeof config._kdFinishLoading === 'function') config._kdFinishLoading()
}

function observeRequestLoading(config) {
  const finish = config._kdFinishLoading
  const adapter = config.adapter || instance.defaults.adapter
  // 适配器闭包保留所属请求，错误没有 config 或后续响应转换抛错也不丢失收尾。
  config.adapter = requestConfig => {
    try {
      return adapter(requestConfig).then(response => {
        finish()
        return response
      }, error => {
        finish()
        return Promise.reject(error)
      })
    } catch (error) {
      finish()
      throw error
    }
  }
  const wrapTransform = transform => function(data, headers) {
    try {
      return transform.call(this, data, headers)
    } catch (error) {
      // 请求转换发生在适配器之前，异常时仍只释放本请求已登记的计数。
      finish()
      throw error
    }
  }
  if (Array.isArray(config.transformRequest)) config.transformRequest = config.transformRequest.map(wrapTransform)
  else if (typeof config.transformRequest === 'function') config.transformRequest = wrapTransform(config.transformRequest)
  // 旧 Axios 的主动取消错误不保证携带 config，不能从错误对象猜测计数归属。
  if (config.cancelToken) config.cancelToken.promise.then(finish)
}

// 添加请求拦截器
instance.interceptors.request.use(config => {
  const loading = createRequestLoading(config)
  try {
    // 请求拦截进来调用显示loading效果
    if (Object.keys(store.state.loading_option).length > 0) {
      if (store.state.loading_option.noneload != undefined && store.state.loading_option.noneload != null) {
        noneload = store.state.loading_option.noneload
      } else if (store.state.loading_option.cancelflag != undefined && store.state.loading_option.cancelflag !=
        null) {
        cancelflag = store.state.loading_option.cancelflag
      } else {
        for (var i in store.state.loading_option) {
          if (load_options[i] != undefined)
            load_options[i] = store.state.loading_option[i]
        }
      }
    }
    console.log('noneload', noneload)
    console.log('cancelflag', cancelflag)
    if (!config.memberSync && noneload == 2 && cancelflag == 2) {
      showLoading(load_options)
      loading.registered = true
      observeRequestLoading(config)
    }

    // 断网提示
    if (!navigator.onLine && shouldNotifyError(config)) {
      MessageBox.alert(
        '您的网络故障，请检查!',
        '温馨提示', {
          confirmButtonText: '好的',
          type: 'warning'
        }
      )
    }

    // 判断是否存在token，如果存在将每个页面header都添加token
    return config
  } catch (error) {
    finishRequestLoading(config)
    throw error
  }
}, error => {
  finishRequestLoading(error.config)
  if (!(error.config && error.config.memberSync)) console.log('请求拦截error', error)
  // 对请求错误做些什么
  return Promise.reject(error)
})

// http response 拦截器
instance.interceptors.response.use(response => {
  finishRequestLoading(response.config)
  var errcode = response.status,
    errmsg = response.statusText
  // ...对状态码进行拦截判断
  if (errcode === 200) {
    return response
  } else {
    if (shouldNotifyError(response.config)) Message.error(errmsg)
    return Promise.reject(response)
  }
}, error => {
  finishRequestLoading(error.config)
  if (!(error.config && error.config.memberSync)) console.log('http response - err', error)
  if (!(error.config && error.config.memberSync) && cancelflag == 2 && shouldNotifyError(error.config))
    Message({
      message: '服务器异常，请稍后再试',
      type: 'error',
      duration: 5 * 1000
    })
  return Promise.reject(new Error('error'))
})

export default instance



// WEBPACK FOOTER //
// ./src/assest/axios/axios.js